import React from "react";
import MarketingNav from "../../components/MarketingNav";
import Footer from "../../components/Footer";
import SEO from "../../components/SEO";
import { Link } from "react-router-dom";
import { Shield, Radar, Boxes, Code2, ArrowRight } from "lucide-react";

export default function Platform() {
  return (
    <div>
      <SEO
        path="/platform"
        title="Platform · Sentry + Observatory"
        description="One platform, two products. Sentry enforces policies on every AI prompt; Observatory stores a signed, queryable record of every decision — the full governance stack for regulated AI."
        keywords="AI governance platform, LLM policy enforcement, AI audit trail, Sentry Observatory, AI compliance platform"
      />
      <MarketingNav />
      <section className="container-x py-16">
        <div className="max-w-3xl">
          <span className="chip chip-orange mb-6"><Boxes size={12}/> Platform</span>
          <h1 className="font-display text-4xl md:text-5xl font-bold text-navy">One platform. Two products. Every AI request.</h1>
          <p className="ink mt-4 text-lg">Sentry enforces. Observatory explains. Together they give you a signed, queryable record of every AI decision your business has ever made.</p>
        </div>
        <div className="grid md:grid-cols-2 gap-6 mt-12">
          <Link to="/sentry" className="group rounded-2xl bg-white border border-[rgba(17,30,51,0.08)] p-8 hover:border-[#FF6B35] transition">
            <div className="flex items-center gap-3">
              <div className="w-11 h-11 rounded-xl bg-[#FF6B35] flex items-center justify-center"><Shield size={20} className="text-white"/></div>
              <div className="font-display text-2xl font-bold text-navy">Sentry</div>
            </div>
            <p className="ink mt-4">In-line AI governance. Screens every prompt against your policies before it reaches a model provider.</p>
            <div className="mt-6 flex items-center gap-2 text-[#FF6B35] font-semibold text-sm">Explore Sentry <ArrowRight size={14} className="group-hover:translate-x-1 transition"/></div>
          </Link>
          <Link to="/observatory" className="group rounded-2xl bg-navy text-cream p-8 hover:ring-2 hover:ring-[#FF6B35] transition">
            <div className="flex items-center gap-3">
              <div className="w-11 h-11 rounded-xl bg-[#FF6B35] flex items-center justify-center"><Radar size={20} className="text-white"/></div>
              <div className="font-display text-2xl font-bold">Observatory</div>
            </div>
            <p className="text-cream/70 mt-4">Post-hoc observability, tracing, and drift-detection across every AI decision.</p>
            <div className="mt-6 flex items-center gap-2 text-[#FFD98A] font-semibold text-sm">Explore Observatory <ArrowRight size={14} className="group-hover:translate-x-1 transition"/></div>
          </Link>
        </div>

        <div className="mt-16 rounded-2xl bg-[#EFEAE1] p-8 border border-[rgba(17,30,51,0.08)]">
          <div className="flex items-center gap-2 mb-3">
            <Code2 size={16} className="text-[#FF6B35]"/>
            <div className="eyebrow ink">Drop-in integration</div>
          </div>
          <pre className="font-mono text-sm text-navy overflow-x-auto bg-white rounded-lg p-4 border border-[rgba(17,30,51,0.08)]">{`# 1. Point your SDK to the Sentry Gateway
export OPENAI_API_BASE="https://gateway.sentry.lunar/v1"

# 2. Every request is now screened, logged, and provable
openai.ChatCompletion.create(model="gpt-4", messages=[...])`}</pre>
        </div>
      </section>
      <Footer />
    </div>
  );
}
